import { Navigate, Outlet } from "react-router-dom"

export default function PublicRoutes(isAuth) {
    return isAuth? <Navigate to="/app/dashboard" replace /> : <Outlet />
}